<input
  class="form-control lna"
  [(ngModel)]="value"
  [ngClass]="{ invalid: invalid }"
  [placeholder]="disabled ? '' : 'HH:mm'"
  [disabled]="disabled"
  (blur)="onBlur()"
  (keypress)="allowOnlySpecifiedCharacters($event)"
  (ngModelChange)="onAnyChange()"
  type="text"
  maxlength="5" />
